"use client";

import { Tabs as RadixTabs } from "radix-ui";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";

import { cn } from "@/services/styles/cn";

const { Root, List, Trigger, Content } = RadixTabs;

const Tabs = Root;

function TabsList({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof List> & { ref?: React.RefObject<ComponentRef<typeof List> | null> }) {
  return (
    <List
      ref={ref}
      className={cn(
        "inline-flex h-10 w-full items-center justify-center rounded-md bg-white-linen-100 p-1 text-muted-foreground lg:h-12",
        className,
      )}
      {...props}
    />
  );
}
TabsList.displayName = List.displayName;

function TabsTrigger({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof Trigger> & { ref?: React.RefObject<ComponentRef<typeof Trigger> | null> }) {
  return (
    <Trigger
      ref={ref}
      className={cn(
        "inline-flex w-full items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 font-semibold text-stone-600 text-xs ring-offset-background transition-all focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-dodger-blue-700 data-[state=active]:text-primary-foreground data-[state=active]:shadow-2xs lg:text-base",
        className,
      )}
      {...props}
    />
  );
}
TabsTrigger.displayName = Trigger.displayName;

function TabsContent({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof Content> & { ref?: React.RefObject<ComponentRef<typeof Content> | null> }) {
  return (
    <Content
      ref={ref}
      className={cn(
        "ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className,
      )}
      {...props}
    />
  );
}
TabsContent.displayName = Content.displayName;

export { Tabs, TabsContent, TabsList, TabsTrigger };
